// extracted by mini-css-extract-plugin
export default {"layoutSwitch":"ProjectsNavigation_layoutSwitch__Z8s2i","paginationSwitch":"ProjectsNavigation_paginationSwitch__nmlE7"};